import React, { useEffect } from 'react';
import './ActionModal.css';

const ActionModal = ({ 
    isOpen, 
    onClose, 
    title = "Acciones",
    itemName = "",
    itemSubtitle = "",
    actions = []
}) => {
    
    // Bloquear scroll
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        /* ⚠️ IMPORTANTE: Aquí NO debe haber onClick={onClose} */
        <div className={`action-modal-overlay ${isOpen ? 'action-modal-overlay-active' : ''}`}>
            
            <div 
                className={`action-modal-container ${isOpen ? 'action-modal-container-active' : ''}`}
                onClick={(e) => e.stopPropagation()} 
            >
                {/* Header */}
                <div className="action-modal-header">
                    <h3 className="action-modal-title">{title}</h3>
                    <button 
                        className="action-modal-close-btn" 
                        onClick={(e) => {
                            e.stopPropagation();
                            onClose(); // Solo la X cierra el modal
                        }}
                    >
                        ✕
                    </button>
                </div>

                {/* Info */}
                {(itemName || itemSubtitle) && (
                    <div className="action-modal-item-info">
                        {itemName && <p className="action-modal-item-name">{itemName}</p>}
                        {itemSubtitle && <p className="action-modal-item-subtitle">{itemSubtitle}</p>}
                    </div>
                )}

                {/* Acciones */}
                <div className="action-modal-actions">
                    {actions.map((action, index) => (
                        <button 
                            key={index}
                            className={`action-modal-button action-modal-${action.variant || 'default'}`}
                            onClick={(e) => {
                                e.stopPropagation(); 
                                action.onClick();
                                if (action.autoClose !== false) {
                                    onClose();
                                }
                            }}
                        >
                            <span className="action-modal-icon">{action.icon}</span>
                            <div className="action-modal-text">
                                <span className="action-modal-action-title">{action.title}</span>
                                {action.subtitle && (
                                    <span className="action-modal-action-subtitle">{action.subtitle}</span>
                                )}
                            </div>
                        </button>
                    ))}
                </div>

                {/* Footer */}
                <div className="action-modal-footer">
                    <button 
                        className="action-modal-cancel-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            onClose(); // Solo el botón Cancelar cierra el modal
                        }}
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ActionModal;